var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.src,"max-width":this.maxHeight},on:{"load":function($event){return _vm.$redrawVueMasonry()}}})}
var staticRenderFns = []

export { render, staticRenderFns }